import { qrcodegen } from "./qr-code-generator.js";

export default function generateQRCode(data, size) {

  //-- Create QR Code
  const eci = qrcodegen.QrSegment.makeEci(26);
  const segments = qrcodegen.QrSegment.makeSegments(data);
  const qrCode = qrcodegen.QrCode.encodeSegments([eci, ...segments], qrcodegen.QrCode.Ecc.MEDIUM);

  const blockSize = size / qrCode.size;
  const parts = [];

  for(let x = 0; x < qrCode.size; x++){
    const xPos = x * blockSize;
    for(let y = 0; y < qrCode.size; y++){
      const yPos = y * blockSize;
      if(qrCode.getModule(x, y)){
        parts.push(`M ${xPos}, ${yPos} V ${yPos + blockSize} H ${xPos + blockSize} V ${yPos} H ${xPos} Z `);
      }
    }

  }

  return parts.join(" ");

}
